import {
  faAddressCard, faAngleLeft, faAngleRight, faAnglesLeft, faAnglesRight, faArrowLeft, faArrowRight, faArrowRotateLeft, faArrowTrendDown, faArrowUpFromBracket,
  faArrowsH, faBank, faBars, faBell, faBolt, faCalendar, faCalendarDays,
  faCaretDown, faCartFlatbed, faChartLine, faChartColumn, faChartPie, faChartArea, faCheck, faCheckSquare,
  faCheckToSlot, faChevronCircleDown, faChevronCircleLeft, faChevronCircleRight,
  faChevronDown, faChevronLeft, faChevronRight, faCircle,   faCircleArrowLeft, faCircleCheck, faCircleDown, faCircleExclamation, faCircleInfo,
  faCircleNotch, faCircleUp, faCircleXmark, faClipboardCheck, faClock, faClockRotateLeft, faClone,
  faClose, faCode, faCodeCompare, faCog, faColumns, faCopy, faDiagramProject, faDownload, faDolly, faDriversLicense,
  faEdit, faEllipsis, faEllipsisVertical, faEnvelope, faEnvelopeOpen,
  faEthernet, faExchange, faExclamation, faExpand, faExternalLink,faCompress,
  faEye, faEyeSlash, faFile, faFileExcel, faFileExport, faFileLines,
  faFileSignature, faFilter, faFilterCircleXmark, faFolderOpen, faGauge,
  faFlask, faGaugeHigh, faGear, faGlobe, faGrip, faHistory, faHeartPulse, faHourglassHalf,
  faInbox, faKey, faLaptop, faLayerGroup, faLeftLong, faLightbulb, faLink, faList, faListAlt,
  faListCheck,
  faLocationCrosshairs, faLocationDot,
  faLock, faLockOpen, faLongArrowRight, faMagnifyingGlassChart, faMailForward,
  faMailReply, faMailReplyAll,   faMapLocationDot, faMemory, faMicrochip, faMinus, faMinusSquare,
  faNetworkWired, faPaperclip, faPalette, faPaste, faPause, faPen, faPenClip, faPeopleGroup,
  faPenToSquare, faPencil, faPersonDigging, faPhone, faPlay, faPlug, faPlus,
  faPlusSquare, faPowerOff, faRefresh, faRotate, faRotateLeft, faRotateRight, faSave,
  faSatelliteDish, faScrewdriverWrench, faSearch, faServer, faShieldHalved, faSignal, faSitemap, faSliders,
  faSort, faSortDown, faSortUp,
  faRankingStar, faSpinner, faStar, faStarOfLife, faStop, faStopwatch, faSync, faTableColumns, faTableList, faTags, faThumbtack,
  faTerminal, faTh, faTimeline, faTimes, faTowerBroadcast, faTrash, faTrashCan, faTriangleExclamation, faTv, faUndo,
  faUpDownLeftRight, faUpload, faUpRightAndDownLeftFromCenter, faUser, faUserCircle, faUsers, faWandMagicSparkles, faWaveSquare,
  faWindowMinimize, faXmark
} from '@fortawesome/free-solid-svg-icons'
import { faExpeditedssl } from '@fortawesome/free-brands-svg-icons'
import { faClock as farClock } from '@fortawesome/free-regular-svg-icons'

export const FA_ICONS = {
  addressCard: faAddressCard,
  angleLeft: faAngleLeft,
  angleRight: faAngleRight,
  anglesLeft: faAnglesLeft,
  anglesRight: faAnglesRight,
  arrowLeft: faArrowLeft,
  arrowRight: faArrowRight,
  arrowRotateLeft: faArrowRotateLeft,
  arrowTrendDown: faArrowTrendDown,
  arrowUpFromBracket: faArrowUpFromBracket,
  arrowsH: faArrowsH,
  bank: faBank,
  bars: faBars,
  bell: faBell,
  bolt: faBolt,
  calendar: faCalendar,
  calendarDays: faCalendarDays,
  caretDown: faCaretDown,
  cartFlatbed: faCartFlatbed,
  chartArea: faChartArea,
  chartColumn: faChartColumn,
  chartLine: faChartLine,
  chartPie: faChartPie,
  check: faCheck,
  checkSquare: faCheckSquare,
  checkToSlot: faCheckToSlot,
  chevronCircleDown: faChevronCircleDown,
  chevronCircleLeft: faChevronCircleLeft,
  chevronCircleRight: faChevronCircleRight,
  chevronDown: faChevronDown,
  chevronLeft: faChevronLeft,
  chevronRight: faChevronRight,
  circle: faCircle,
  circleArrowLeft: faCircleArrowLeft,
  circleCheck: faCircleCheck,
  circleDown: faCircleDown,
  circleExclamation: faCircleExclamation,
  circleInfo: faCircleInfo,
  circleNotch: faCircleNotch,
  circleUp: faCircleUp,
  circleXmark: faCircleXmark,
  clipboardCheck: faClipboardCheck,
  clock: faClock,
  clockRegular: farClock,
  clockRotateLeft: faClockRotateLeft,
  clone: faClone,
  close: faClose,
  code: faCode,
  codeCompare: faCodeCompare,
  cog: faCog,
  columns: faColumns,
  copy: faCopy,
  diagramProject: faDiagramProject,
  download: faDownload,
  dolly: faDolly,
  driversLicense: faDriversLicense,
  edit: faEdit,
  ellipsis: faEllipsis,
  ellipsisVertical: faEllipsisVertical,
  envelope: faEnvelope,
  envelopeOpen: faEnvelopeOpen,
  ethernet: faEthernet,
  exchange: faExchange,
  exclamation: faExclamation,
  expand: faExpand,
  compress: faCompress,
  expeditedSsl: faExpeditedssl,
  externalLink: faExternalLink,
  eye: faEye,
  eyeSlash: faEyeSlash,
  file: faFile,
  fileExcel: faFileExcel,
  fileExport: faFileExport,
  fileLines: faFileLines,
  fileSignature: faFileSignature,
  filter: faFilter,
  filterCircleXmark: faFilterCircleXmark,
  flask: faFlask,
  folderOpen: faFolderOpen,
  gauge: faGauge,
  gaugeHigh: faGaugeHigh,
  gear: faGear,
  globe: faGlobe,
  grip: faGrip,
  heartPulse: faHeartPulse,
  history: faHistory,
  hourglassHalf: faHourglassHalf,
  inbox: faInbox,
  key: faKey,
  laptop: faLaptop,
  layerGroup: faLayerGroup,
  leftLong: faLeftLong,
  lightbulb: faLightbulb,
  link: faLink,
  list: faList,
  listAlt: faListAlt,
  listCheck: faListCheck,
  locationCrosshairs: faLocationCrosshairs,
  locationDot: faLocationDot,
  lock: faLock,
  lockOpen: faLockOpen,
  longArrowRight: faLongArrowRight,
  magnifyingGlassChart: faMagnifyingGlassChart,
  mailForward: faMailForward,
  mailReply: faMailReply,
  mailReplyAll: faMailReplyAll,
  mapLocationDot: faMapLocationDot,
  memory: faMemory,
  microchip: faMicrochip,
  minus: faMinus,
  minusSquare: faMinusSquare,
  networkWired: faNetworkWired,
  paperclip: faPaperclip,
  palette: faPalette,
  paste: faPaste,
  pause: faPause,
  pen: faPen,
  penClip: faPenClip,
  penToSquare: faPenToSquare,
  pencil: faPencil,
  peopleGroup: faPeopleGroup,
  personDigging: faPersonDigging,
  phone: faPhone,
  play: faPlay,
  plug: faPlug,
  plus: faPlus,
  plusSquare: faPlusSquare,
  powerOff: faPowerOff,
  refresh: faRefresh,
  rotate: faRotate,
  rotateLeft: faRotateLeft,
  rotateRight: faRotateRight,
  rankingStar: faRankingStar,
  save: faSave,
  satelliteDish: faSatelliteDish,
  screwdriverWrench: faScrewdriverWrench,
  search: faSearch,
  server: faServer,
  shieldHalved: faShieldHalved,
  signal: faSignal,
  sitemap: faSitemap,
  sliders: faSliders,
  sort: faSort,
  sortDown: faSortDown,
  sortUp: faSortUp,
  spinner: faSpinner,
  star: faStar,
  starOfLife: faStarOfLife,
  stop: faStop,
  stopwatch: faStopwatch,
  sync: faSync,
  tableColumns: faTableColumns,
  tableList: faTableList,
  tags: faTags,
  thumbtack: faThumbtack,
  terminal: faTerminal,
  th: faTh,
  timeline: faTimeline,
  times: faTimes,
  towerBroadcast: faTowerBroadcast,
  trash: faTrash,
  trashCan: faTrashCan,
  triangleExclamation: faTriangleExclamation,
  tv: faTv,
  undo: faUndo,
  upDownLeftRight: faUpDownLeftRight,
  upload: faUpload,
  upRightAndDownLeftFromCenter: faUpRightAndDownLeftFromCenter,
  user: faUser,
  userCircle: faUserCircle,
  users: faUsers,
  wandMagicSparkles: faWandMagicSparkles,
  waveSquare: faWaveSquare,
  windowMinimize: faWindowMinimize,
  xmark: faXmark
}
